<template>
  <button
    class="category h-28 transition-all flex justify-center items-center flex-col relative"
    :class="{ 'active': active }"
    @click.prevent="e => $emit('select', e)">
    <div
      class="absolute left-2 top-2 w-5 h-5 rounded-full flex justify-center items-center"
      :class="{
        'bg-white text-black': !active,
        'bg-black text-white': active
      }">
      <svg v-if="active" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
    </div>
    <svg v-if="icon" class="w-10 h-10 mb-1">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="`#icon-${icon}`" />
    </svg>
    <span class="text-sm">
      {{ label }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'Category',
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.category {
  background-color: #e5e3e1;
  border-right: 1px solid white;
  border-top: 1px solid white;
}

.category:focus, .category:hover {
  background-color: #d9d6d3;
}

.category:focus:active, .category:hover:active, .active {
  background-color: #bebab3;
}

.category.active:hover, .category.active:hover {
  background-color: #b2aea5;
}

.category.active:active:hover, .category.active:active:hover {
  background-color: #d9d6d3;
}
</style>
